import { Accordion, AccordionDetails, AccordionSummary, Box, Menu, MenuItem, Typography } from "@mui/material";
import { CloneIcon, SettingIcon } from "../../../../assets/common-svg/CommonSvg.js";
import FormField from "../common/FormField.js";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useFormContext } from "react-hook-form";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useState } from "react";
import DeleteModal from "../../../../bmr/components/common/BaseModal/DeleteModal/index.js";

const FormInput = ({
  index,
  sectionIndex,
  selectedField,
  handleAppendField,
  handleRemoveField,
  setSelectedField,
  schema,
  noOfFields,
  isFieldAdd
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { watch, formState: { errors } } = useFormContext();
  const[ openModal, setOpenModal]=useState(false);
  const [removeFieldId, setRemoveFieldId]=useState([])
  const fieldData = watch(`sections.${sectionIndex}.fields.${index}`);
  const hasFieldError = !!errors?.sections?.[sectionIndex]?.fields?.[index];
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: schema.input_uuid,
  });
  const field_type = watch(`sections.${sectionIndex}.fields.${index}.property.field_type`);
  const noPlaceholderTypes = ['Label', 'Hyperlink', 'Input Radio', 'Toggle', 'Barcode'];
  const hidePlaceholder = noPlaceholderTypes.includes(field_type);
    const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "12px",
    margin: "0px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "#fff",
  };
  const handleAccept=()=>{
    handleRemoveField(removeFieldId)
    setOpenModal(false);
  }
  return (
    <Box className={`bg-white`} ref={setNodeRef}
      style={style}
      {...attributes}>
      <Box className={`border ${hasFieldError ? '!border-red-500' : selectedField === schema.input_uuid ? 'border-primary' : ''} bg-gray-200 mt-3 p-3 rounded-[10px] relative`}>
        <Accordion
          expanded={selectedField === schema.input_uuid}
          onChange={(e, isExpanded) =>{ 
           setSelectedField(isExpanded ? schema.input_uuid : '');
          }}
          className="shadow-none m-0"
          sx={{
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${sectionIndex}-${index}-content`}
            id={`panel-${sectionIndex}-${index}-header`}
          >
            <Typography className="text-sm mb-2 break-all capitalize">
              {sectionIndex + 1}.{index + 1} {fieldData?.label || 'Untitled Field'}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <FormField
              name={`sections.${sectionIndex}.fields.${index}.label`}
              label="Field Label"
              placeholder="Enter the Field Label"
              className="capitalize"
            />
            {!hidePlaceholder &&
              <FormField
                name={`sections.${sectionIndex}.fields.${index}.placeholder`}
                label="Placeholder text"
                className="capitalize "
                placeholder="Enter the Placeholder text"
              />
            }
          </AccordionDetails>
        </Accordion>
        <div>
          <div className="absolute bg-white shadow-[0px_2px_8px_3px_#0000001A] -top-4 -left-2 m-0 rounded-full cursor-grab active:cursor-grabbing">
            <DragIndicatorIcon className="m-1 text-[15px]" {...listeners} />
          </div>

          <div className="absolute flex c-icons-position z-10">
           <div onClick={!isFieldAdd ? handleAppendField : undefined} className={`${isFieldAdd? 'cursor-not-allowed' : 'cursor-pointer'}`}>
              <CloneIcon className="w-6 h-6 text-gray-600 hover:text-gray-800" />
            </div>
            {noOfFields !== 1 && (
              <>
            <div onClick={handleOpen} className="cursor-pointer"> 
              <SettingIcon className="cursor-pointer text-gray-600 hover:text-gray-800" />
            </div>
              <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    PaperProps={{
                      sx: {
                        mt: 0.5,
                        boxShadow: 3,
                        borderRadius: 1.5,
                        minWidth: 120,
                      },
                    }}
                  >
                    
                    <MenuItem
                      onClick={() => {
                        setOpenModal(true);
                        setRemoveFieldId({fieldId: schema.input_uuid, index:index});
                        handleClose();
                      }}
                    >
                      Remove
                    </MenuItem>
                  </Menu>
                  </>
                  )}
          </div>
        </div>
      </Box>
      <DeleteModal
        open={openModal}
        setClose={setOpenModal}
        title="Are you sure you want to Delete?"
        handleSuccess={handleAccept}
        handleRejection={() => {
          setOpenModal(false);
        }}
        buttonText="Delete"
      />
    </Box>
  );
};

export default FormInput;
